import { combineReducers } from "redux";

import { IProfile } from "../api/APIClient";
import { RootAction } from "../types";
import { AdminCall } from "dialup";

function isLoading(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case "CREATE_BROADCAST_REQUEST":
    case "LIST_MORE_CALLS_REQUEST":
    case "UPDATE_CALL_REQUEST":
      return true;
    case "CREATE_BROADCAST_FAILURE":
    case "CREATE_BROADCAST_SUCCESS":
    case "LIST_MORE_CALLS_FAILURE":
    case "LIST_MORE_CALLS_SUCCESS":
    case "UPDATE_CALL_FAILURE":
    case "UPDATE_CALL_SUCCESS":
      return false;
    default:
      return state;
  }
}

function list(
  state: Array<string | undefined> = [],
  action: RootAction
): Array<string | undefined> {
  switch (action.type) {
    case "LIST_CALLS_SUCCESS":
      return action.payload.calls.map((call: AdminCall) => call.id);

    case "LIST_MORE_CALLS_SUCCESS":
      const { reply, request } = action.payload;

      const chunkOffset = request.offset || 0;
      const chunkLimit = request.limit || 0;
      const chunkEnd = chunkOffset + chunkLimit;

      let listLen = state.length;
      if (chunkEnd > listLen) {
        listLen = chunkEnd;
      }

      const newState = new Array<string | undefined>(listLen);

      for (let i = 0; i < state.length; i++) {
        newState[i] = state[i];
      }

      for (let i = 0; i < reply.calls.length; i++) {
        newState[i + chunkOffset] = reply.calls[i].id;
      }

      return newState;

    default:
      return state;
  }
}

function listSize(
  state: number | null = null,
  action: RootAction
): number | null {
  switch (action.type) {
    case "LIST_CALLS_SUCCESS":
      return null;

    case "LIST_MORE_CALLS_SUCCESS":
      const { reply, request } = action.payload;
      const { calls } = reply;

      const offset = request.offset || 0;
      const limit = request.limit || 0;
      const chunkEnd = offset + calls.length;

      if (calls.length < limit) {
        return state ? Math.min(state, chunkEnd) : chunkEnd;
      }

      return state;

    default:
      return state;
  }
}

function data(
  state: { [id: string]: AdminCall } = {},
  action: RootAction
): { [id: string]: AdminCall } {
  let call: AdminCall;
  switch (action.type) {
    case "UPDATE_CALL_SUCCESS":
      call = action.payload.call;
      return { ...state, [call.id]: call };

    case "LIST_MORE_CALLS_SUCCESS":
      state = { ...state };

      for (call of action.payload.reply.calls) {
        state[call.id] = call;
      }

      return state;

    case "LIST_CALLS_SUCCESS":
      state = { ...state };

      for (call of action.payload.calls) {
        state[call.id] = call;
      }

      return state;

    default:
      return state;
  }
}

function modalOpen(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case "TOGGLE_CALL_MODAL_OPEN":
      return !state;
    case "CREATE_BROADCAST_SUCCESS":
      return false;
    default:
      return state;
  }
}

function callAudience(state: IProfile[] = [], action: RootAction): IProfile[] {
  switch (action.type) {
    case "TOGGLE_CALL_MODAL_OPEN":
      return [];
    case "GET_BROADCAST_AUDIENCE_SUCCESS":
      return action.payload;
    default:
      return state;
  }
}

function updateError(state: string = "", action: RootAction): string {
  switch (action.type) {
    case "UPDATE_CALL_REQUEST":
      return "";
    case "UPDATE_CALL_FAILURE":
      return action.payload.message;
    default:
      return state;
  }
}

export const callsReducer = combineReducers({
  data,
  list,
  listSize,
  isLoading,
  modalOpen,
  callAudience,
  updateError,
});
export default callsReducer;



// WEBPACK FOOTER //
// ./src/reducers/callsReducer.ts